/* eslint-disable no-mixed-operators */
import React from "react";

import { Grid, Typography, Box, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "react-hot-toast";
import { useSelector } from "react-redux";

import FavoriteButton from "../Lobby/FavoriteButton/FavoriteButton";
import useStyles from "../Lobby/Lobby.styles";

const Game = ({
  thumbnailUrl,
  name,
  gameId,
  handleSearchBox,
  searchGame,
  isFavorite = null,
  providerName,
  recallFav = null,
  providerId,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const Navigate = useNavigate();

  const { isLoggedIn } = useSelector((state) => state.authentication);

  const handleGameLaunch = (e) => {
    if (!isLoggedIn) {
      toast.error(t("GAME.GAME_LOGIN_MSG"), {
        id: "GAME_LOGIN_MSG",
      });
      return;
    }
    if (searchGame) {
      handleSearchBox();
    }
    const playerWalletType = localStorage.getItem("selectedWallet") || "coin";
    if (providerId === 37 && playerWalletType !== "gold") {
      return toast.error(
        "In House Games Are Not Support For Bonus Coin Yet, Please Choose Gold Coin To Play This Game",
        {
          id: "wallet type",
        }
      );
    }
    localStorage.setItem("backGame", true);
    Navigate(`/game/${gameId}`);
  };
  const handleImageError = (e) => {
    e.target.onerror = null; // Prevent potential infinite loop if the default image also fails to load.
    e.target.src = "/images/HRD.png"; // Replace with the path to your default image.
    e.target.alt = "Default Image"; //
  };
  return (
    <Grid item className={classes.sliderGame}>
      <Grid className={classes.casinoCard}>
        <Grid
          to={
            providerId === 37 &&
            localStorage.getItem("selectedWallet") !== "gold"
              ? ""
              : `/game/${gameId}`
          }
          style={{ height: "100%" }}
        >
          <img
            src={thumbnailUrl || "/images/HR.png"}
            onError={handleImageError}
            alt="Casino Card"
          />
          <Box className={`${classes.imageHover}`}>
            {isLoggedIn && (
              <FavoriteButton
                isFavorite={isFavorite}
                favBtnClass={classes.favIconWrap}
                gameId={gameId}
                recallFav={recallFav}
              />
            )}
            <Button
              type="button"
              className="playBtn"
              onClick={() => handleGameLaunch(providerId)}
            >
              <img
                src="/images/play-btn.svg"
                alt="play btn"
                className={classes.playBtn}
                d
              />
              {/* <p>{name}</p> */}
              <p className={classes.providerName}>{name || "Provider"}</p>
            </Button>
          </Box>
        </Grid>
      </Grid>

      <Grid className={classes.casinoOverlay}>
        <Typography>
          {(name && name?.replace(/([a-z])([A-Z])/g, "$1 $2")) || "Game"}
          {/* {name &&
            (name.toUpperCase().includes("VVIP")
              ? "VVIP"
              : name.toUpperCase().includes("SUPERVIP")
              ? name.toUpperCase().replace("SUPERVIP", "")
              : name.toUpperCase().includes("VIP")
              ? name.toUpperCase().replace("VIP", "")
              : name)} */}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default Game;
